import list from 'src/modules/responsibleConsumption/list/responsibleConsumptionListReducers';
import form from 'src/modules/responsibleConsumption/form/responsibleConsumptionFormReducers';
import view from 'src/modules/responsibleConsumption/view/responsibleConsumptionViewReducers';
import destroy from 'src/modules/responsibleConsumption/destroy/responsibleConsumptionDestroyReducers';
import importerReducer from 'src/modules/responsibleConsumption/importer/responsibleConsumptionImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
